import React from "react";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import FunctionsData from "../../../Functions/FunctionsData";

export default function VoucherMarkAsUnused({open,setOpen, voucher, setLoadingVouchers}) {

    const [accept, setAccept] = React.useState(false);

    function removeRedemption() {
        FunctionsData.postData(
            FunctionsData.getApiUrl('/api/voucher/update/')+voucher.id,
            {
                marked_unused:1
            })
            .then(data => {
                console.log(data);
                setLoadingVouchers(true);
                setOpen(false);
            })
            .catch(err => {
                console.log(err);
            })
    }

    return (
        <Dialog open={open} onClose={() => setOpen(false)}>
            <DialogTitle>Remove unused voucher</DialogTitle>
            <DialogContent>
                <div style={{padding:'0 20px'}}>
                    <ul>
                        <li>Serial: {voucher.sn}</li>
                        <li>Name: {voucher.a_name}</li>
                        <li>Animal: {voucher.a_type} {voucher.animal_gender}</li>
                        <li>Campaign: {voucher.campaign_name}</li>
                    </ul>
                </div>

                {/* <pre>
                    {JSON.stringify(voucher, null, 2)}<br/>
                </pre> */}

                <div style={{marginTop:20}}>
                    <input type={"checkbox"} onChange={(e) => setAccept(e.target.checked)} /> I understand that this action cannot be undone.
                </div>

            </DialogContent>
            <DialogActions>
                <Button onClick={() => setOpen(false)}>Cancel</Button>
                <Button variant={"contained"} disabled={!accept} onClick={removeRedemption}>Remove voucher</Button>
            </DialogActions>
        </Dialog>
    )
}
